import { render, staticRenderFns } from "./EmbeddedResourceModal.vue?vue&type=template&id=5f4fa38a&scoped=true&"
import script from "./EmbeddedResourceModal.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedResourceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4fa38a",
  null
  
)

export default component.exports